import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for  add map strategy
export const MapStrategies = createSlice({
  name: "AddMapStrategies",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    switchResponse: false,
    data: [],
  },
  reducers: {
    add_AddMapStrategies: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_add_AddMapStrategies: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
      state.switchResponse = true;
    },
    failure_api_call_add_AddMapStrategies: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
      state.switchResponse = true;
    },
    add_AddMapStrategies_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_AddMapStrategies_complete_api: (state, action) => {
      state.api_completed = false;
    },
    clear_add_Data: (state) => {
      state.data = [];
    },
    false_switchmapadd_response: (state) => {
      state.switchResponse = false;
    },
  },
});
export default MapStrategies.reducer;
export const {
  add_AddMapStrategies,
  success_api_call_add_AddMapStrategies,
  failure_api_call_add_AddMapStrategies,
  create_AddMapStrategies_complete_api,
  add_AddMapStrategies_is_success,
  clear_add_Data,
  false_switchmapadd_response
} = MapStrategies.actions;
